import React, { useCallback, useMemo, useState } from 'react';

import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';

const SidebarContext = React.createContext(null);

const top = [
  {
    key: 'home',
    label: 'Home',
    to: '/',
    icon: <DashboardOutlinedIcon />,
  },
];

const bottom = [
  {
    key: 'logout',
    label: 'Logout',
    to: '/auth/logout',
    icon: <LogoutOutlinedIcon />,
  },
];


function SidebarProvider({ children }) {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const open = useCallback(() => {
    setIsCollapsed(false);
  }, []);

  const collapse = useCallback(() => {
    setIsCollapsed(true);
  }, []);

  const toggle = useCallback(() => {
    setIsCollapsed((prevValue) => !prevValue);
  }, []);

  const contextValue = useMemo(() => ({
    isCollapsed,
    open,
    collapse,
    toggle,
    items: {
      top,
      bottom,
    },
  }), [collapse, isCollapsed, open, toggle]);

  return <SidebarContext.Provider value={contextValue}>{children}</SidebarContext.Provider>;
}

SidebarProvider.displayName = 'SidebarProvider';
export { SidebarContext, SidebarProvider };
